import moment from 'moment';
import { Svg } from 'assets';

export const AlertTabEnum = {
    EXPIRING: 'Expiring',
    EXPIRED: 'Expired',
};

export const AlertTabs = [
    { key: AlertTabEnum.EXPIRING, label: 'Expiring', countBg: '#FFFBEB', countColor: '#B45309' },
    { key: AlertTabEnum.EXPIRED, label: 'Expired', countBg: '#FFF1F2', countColor: '#B42318' },
];

export const UpcomingApptTab = {
    UPCOMING: 'UPCOMING',
    OVERDUE: 'OVERDUE',
};

export const UpcomingApptTabs = [
    { key: UpcomingApptTab.UPCOMING, label: 'Upcoming', countBg: '#EAECF0', countColor: '#344054' },
    { key: UpcomingApptTab.OVERDUE, label: 'Overdue', countBg: '#FEF3F2', countColor: '#B42318' },
];

export const MyTasksTabs = [
    { label: 'Overdue', key: 'overdue', color: '#B42318', background: '#FEF3F2' },
    { label: 'Due Today', key: 'dueToday', color: '#B54708', background: '#FFFAEB' },
    { label: 'Upcoming', key: 'upcoming', color: '#475467', background: '#FAFAFA' },
];

export const MyTasksEmptyStates = {
    overdue: {
        title: 'No overdue tasks 🎉',
        description: 'Great job staying on track',
    },
    dueToday: {
        title: 'No tasks due today 🎯',
        description: 'Enjoy a clear schedule',
    },
    upcoming: {
        title: 'No upcoming tasks 📋',
        description: 'Nothing on the horizon',
    },
};

export const formatDueDate = (dueDate) => {
    const today = moment.utc().startOf('day');
    const due = moment.utc(dueDate).startOf('day');
    const diffDays = today.diff(due, 'days');

    if (diffDays === 0) return 'Due Today';
    if (diffDays === 1) return 'Due Yesterday';
    if (diffDays === -1) return 'Due Tomorrow';
    if (diffDays > 1) return `Due ${diffDays} days ago`;
    return `Due in ${Math.abs(diffDays)} days`;
};

export const getDueDateColor = (dueDate) => {
    const today = moment.utc().startOf('day');
    const due = moment.utc(dueDate).startOf('day');
    const diffDays = today.diff(due, 'days');

    if (diffDays > 0) return '#F04438';
    if (diffDays === 0) return '#DC6803';
    return '#667085';
};

export const formatExpiration = (item) => {
    const today = moment.utc();
    const expDate = moment(item?.expirationDate).utc();
    const diffDays = today.diff(expDate, 'days');
    const formattedDate = expDate.format('MM/DD/YY');

    if (diffDays >= 0) {
        return `Expired on: ${formattedDate} (${diffDays} days ago)`;
    }
    return `Expires on: ${formattedDate} (in ${Math.abs(diffDays)} days)`;
};

export const getDaysLabel = (daysRemaining) => {
    if (daysRemaining <= 0) return 'Expires today';
    if (daysRemaining === 1) return 'Expires in 1 day';
    return `Expires in ${daysRemaining} days`;
};

export const WidgetEnumsDashboard = {
    CLIENT: 'CLIENT',
    PAYROLL: 'PAYROLL',
    STAFF: 'STAFF',
    FS_SOURCE: 'FS_SOURCE',
    APPT: 'APPT',
    BILLING: 'BILLING',
};

export const WidgetCategoriesDashboard = [
    { name: 'Client', id: WidgetEnumsDashboard.CLIENT },
    // {name: 'Payroll', id: WidgetEnumsDashboard.PAYROLL },
    { name: 'Staff', id: WidgetEnumsDashboard.STAFF },
    // {name: 'FS Source', id: WidgetEnumsDashboard.FS_SOURCE },
    { name: 'Appointment', id: WidgetEnumsDashboard.APPT },
    // {name: 'Billing', id: WidgetEnumsDashboard.BILLING },
];

export const checkFilter = (inputs, i) => {
    if (inputs?.category) {
        return i?.category === inputs?.category;
    }
    return true;
};

export const WidgetMeta = {
    1: { title: 'My Appointments', glyph: Svg.UpcomingApptWidgetDash, bg: '#EFF6FF', color: '#2563EB' },
    2: { title: 'Clients Overview', glyph: Svg.ClientOverviewWidgetDash, bg: '#FFF1F2', color: '#E11D48' },
    3: { title: 'Credential Alerts', glyph: Svg.ExpiringCredWidgetDash, bg: '#FFFBEB', color: '#D97706' },
    4: { title: 'Notifications & Alerts', glyph: Svg.NotAlertsWidgetDash, bg: '#FFFBEB', color: '#F59E0B' },
    5: { title: 'Assigned Clients', glyph: Svg.AssignedClientsWidgetDash, bg: '#ECFDF5', color: '#059669' },
    6: { title: 'My Profile', glyph: Svg.MyProfileWidgetDash, bg: '#EEF2FF', color: '#6366F1' },
    8: { title: 'My Tasks', glyph: Svg.MyTasksWidgetDash, bg: '#F0F9FF', color: '#0284C7' },
    10: { title: 'Expiring Authorizations', glyph: Svg.ExpiringAuthWidgetDash, bg: '#FFFBEB', color: '#D97706' },
    11: { title: 'Insurance Alerts', glyph: Svg.InsuranceAlertsWidgetDash, bg: '#FFF1F2', color: '#F43F5E' },
    12: { title: 'Session Note Requests', glyph: Svg.SessionNoteReqWidgetDash, bg: '#E6F5EE', color: '#026C3C' },
    13: { title: 'Client Document Alerts', glyph: Svg.ExpiringCredWidgetDash, bg: '#F5F3FF', color: '#7C3AED' },
};

export const RenderWidgetImage = (id, variant = 'badge') => {
    const meta = WidgetMeta[id] || WidgetMeta[1];
    const Glyph = meta.glyph;
    const style = variant === 'badge' ? { background: meta.bg, color: meta.color } : undefined;

    return (
        <div className={`widget-icon-badge widget-icon-badge--${variant}`} style={style}>
            <Glyph />
        </div>
    );
};
